import * as React from "react"
const SvgPersonalization = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M18 13.143q.424 0 .712-.288a.97.97 0 0 0 .288-.712.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-3a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712.288.288.713.288zm0-3q.424 0 .712-.288A.97.97 0 0 0 19 9.143a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-3a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712.288.288.713.288zm-9 3q-.9 0-1.625.162a4 4 0 0 0-1.275.513q-.525.324-.8.737a1.57 1.57 0 0 0-.275.888q0 .3.225.5a.8.8 0 0 0 .55.2h6.4q.325 0 .55-.213a.7.7 0 0 0 .225-.537q0-.426-.275-.825-.275-.4-.8-.75a4 4 0 0 0-1.275-.513A7.5 7.5 0 0 0 9 13.143m0-1q.825 0 1.412-.588.588-.587.588-1.412t-.588-1.413A1.93 1.93 0 0 0 9 8.143q-.825 0-1.412.587A1.93 1.93 0 0 0 7 10.143q0 .825.588 1.412.587.588 1.412.588m-5 8q-.824 0-1.413-.588A1.93 1.93 0 0 1 2 18.143v-12q0-.825.587-1.413A1.93 1.93 0 0 1 4 4.143h16q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm0-2h16v-12H4z" />
  </svg>
)
export default SvgPersonalization
